function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* global rmlOpts */
import React from "react";
import { blocks, components, element, editor, i18n } from "wp";
var BLOCK_ID = "real-media-library/gallery",
    registerBlockType = blocks.registerBlockType,
    G = components.G,
    SVG = components.SVG,
    Path = components.Path,
    ServerSideRender = components.ServerSideRender,
    PanelBody = components.PanelBody,
    RangeControl = components.RangeControl,
    ToggleControl = components.ToggleControl,
    SelectControl = components.SelectControl,
    TreeSelect = components.TreeSelect,
    Notice = components.Notice,
    Spinner = components.Spinner,
    Button = components.Button,
    withNotices = components.withNotices,
    Component = element.Component,
    Fragment = element.Fragment,
    InspectorControls = editor.InspectorControls,
    __ = i18n.__;
var linkOptions = [{
  value: "attachment",
  label: __("Attachment Page")
}, {
  value: "media",
  label: __("Media File")
}, {
  value: "none",
  label: __("None")
}];
/**
 * Control to select a folder. You do not have to fill the items, it is
 * automatically filled and retrieved from the server.
 */

var SelectFolderControl = /*#__PURE__*/function (_Component) {
  _inherits(SelectFolderControl, _Component);

  var _super = _createSuper(SelectFolderControl);

  function SelectFolderControl() {
    var _this;

    _classCallCheck(this, SelectFolderControl);

    _this = _super.apply(this, arguments);
    _this.state = {
      $busy: true,
      tree: []
    };
    return _this;
  }
  /**
   * Load the RML tree.
   */


  _createClass(SelectFolderControl, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$window$rml$req, tree;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return window.rml.request({
                  location: {
                    path: "/tree"
                  }
                });

              case 2:
                _yield$window$rml$req = _context.sent;
                tree = _yield$window$rml$req.tree;
                tree.unshift({
                  id: -1,
                  name: rmlOpts.others.lang.unorganized
                });
                tree.unshift({
                  id: undefined,
                  name: "-"
                });
                this.setState({
                  tree: tree,
                  $busy: false
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var rest = _extends({}, this.props),
          _this$state = this.state,
          $busy = _this$state.$busy,
          tree = _this$state.tree;

      return !$busy ? /*#__PURE__*/React.createElement(TreeSelect, _extends({
        label: rmlOpts.others.lang.folder
      }, rest, {
        tree: tree
      })) : /*#__PURE__*/React.createElement(Spinner, null);
    }
  }]);

  return SelectFolderControl;
}(Component);
/**
 * Gallery edit view with inspector controls like the normal gallery block.
 */


var GalleryEdit = /*#__PURE__*/function (_Component2) {
  _inherits(GalleryEdit, _Component2);

  var _super2 = _createSuper(GalleryEdit);

  function GalleryEdit() {
    var _this2;

    _classCallCheck(this, GalleryEdit);

    _this2 = _super2.apply(this, arguments);

    _this2.setFid = function (fid) {
      return _this2.props.setAttributes({
        fid: +fid
      });
    };

    _this2.setLinkTo = function (linkTo) {
      return _this2.props.setAttributes({
        linkTo: linkTo
      });
    };

    _this2.setColumnsNumber = function (columns) {
      return _this2.props.setAttributes({
        columns: columns
      });
    };

    _this2.toggleImageCrop = function () {
      return _this2.props.setAttributes({
        imageCrop: !_this2.props.attributes.imageCrop
      });
    };

    _this2.toggleCaptions = function () {
      return _this2.props.setAttributes({
        captions: !_this2.props.attributes.captions
      });
    };

    _this2.handleReload = function () {
      return _this2.props.setAttributes({
        lastEditReload: new Date().getTime()
      });
    };

    _this2.render = function () {
      // Collect data
      var attributes = _this2.props.attributes,
          fid = attributes.fid,
          _attributes$columns = attributes.columns,
          columns = _attributes$columns === void 0 ? 3 : _attributes$columns,
          imageCrop = attributes.imageCrop,
          captions = attributes.captions,
          linkTo = attributes.linkTo;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(InspectorControls, null, /*#__PURE__*/React.createElement(PanelBody, {
        title: __("Gallery Settings")
      }, /*#__PURE__*/React.createElement(SelectFolderControl, {
        value: fid,
        onChange: _this2.setFid
      }), /*#__PURE__*/React.createElement(RangeControl, {
        label: __("Columns"),
        value: columns,
        onChange: _this2.setColumnsNumber,
        min: "1",
        max: "8"
      }), /*#__PURE__*/React.createElement(ToggleControl, {
        label: __("Crop Images"),
        checked: !!imageCrop,
        onChange: _this2.toggleImageCrop
      }), /*#__PURE__*/React.createElement(ToggleControl, {
        label: __("Caption"),
        checked: !!captions,
        onChange: _this2.toggleCaptions
      }), /*#__PURE__*/React.createElement(SelectControl, {
        label: __("Link To"),
        value: linkTo,
        onChange: _this2.setLinkTo,
        options: linkOptions
      }), /*#__PURE__*/React.createElement(Button, {
        isPrimary: true,
        onClick: _this2.handleReload
      }, rmlOpts.others.lang.reloadContent))), /*#__PURE__*/React.createElement(ServerSideRender, {
        block: BLOCK_ID,
        attributes: attributes
      }), !fid && /*#__PURE__*/React.createElement(Notice, {
        status: "error",
        isDismissible: false
      }, /*#__PURE__*/React.createElement("p", null, rmlOpts.others.lang.gutenBergBlockSelect)));
    };

    _this2.state = {
      refresh: new Date().getTime()
    };
    return _this2;
  }

  return GalleryEdit;
}(Component);
/**
 * @see https://github.com/WordPress/gutenberg/blob/master/packages/block-library/src/gallery/index.js
 */


registerBlockType(BLOCK_ID, {
  title: "Real Media Library Gallery",
  description: "Display folder images in a rich gallery.",
  icon: /*#__PURE__*/React.createElement(SVG, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement(G, null, /*#__PURE__*/React.createElement(Path, {
    d: "M20 4v12H8V4h12m0-2H8L6 4v12l2 2h12l2-2V4l-2-2z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M12 12l1 2 3-3 3 4H9z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M2 6v14l2 2h14v-2H4V6H2z"
  }))),
  category: "common",
  supports: {
    align: true
  },
  attributes: {
    fid: {
      type: "number",
      default: 0
    },
    columns: {
      type: "number",
      default: 3
    },
    imageCrop: {
      type: "boolean",
      default: true
    },
    captions: {
      type: "boolean",
      default: true
    },
    linkTo: {
      type: "string",
      default: "none"
    },
    lastEditReload: {
      type: "number",
      default: 0
    }
  },
  edit: withNotices(GalleryEdit),
  save: function save() {
    // Rendering in PHP, see general\Gutenberg
    return null;
  }
});